import { type SxProps, type Theme } from '@mui/material';

export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: 'inherit',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    bgcolor: '#fff',
    height: '90.54px',
    pl: '19.76px',
    pr: '19.76px',
    flexShrink: 0,
    borderBottom: '0.82px solid #E8E8E8',
  },
  title: {
    fontFamily: 'Manrope',
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '30px',
    letterSpacing: 0,
    color: '#000',
  },
  icon: {
    color: 'black',
    fontSize: '24px',
  },
  body: {
    p: 2,
    fontSize: '16px',
    lineHeight: '24px',
  },
  actions: ({ palette: { border } }) => ({
    boxShadow: '0 0 8px rgba(0, 0, 0, 0.1)',
    borderTop: `1px solid ${border.main}`,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 2,
    p: 2,
  }),
} satisfies SxProps<Theme>;
